module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/investment/investment-menu/investment-menu.component.css
// module id = ./src/app/investment/investment-menu/investment-menu.component.css
// module chunks = main